// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","topicChoice":"App_topicChoice__efRta"};